import { downloadMerchantFile, getMerchantFile } from 'APIs/files/files';
import { MerchantFileResponse } from 'APIs/files/files.types';

import FileViewerModal from './FileViewerModal';

export const FileViewer = FileViewerModal;

export const downloadFile = async (
  apiBaseUri: string,
  merchantId: string,
  fileId: string,
): Promise<{ fileUrl: string; fileType: string } | null> => {
  let fileUrl: string | null = null;
  let fileData: MerchantFileResponse | null = null;

  try {
    fileUrl = await downloadMerchantFile(apiBaseUri, merchantId, fileId);
    fileData = await getMerchantFile(apiBaseUri, merchantId, fileId);
  } catch (error) {
    console.log(error);
  } finally {
    if (fileUrl && fileData) {
      return { fileUrl, fileType: fileData.fileType };
    } else return null;
  }
};

export default FileViewer;
